
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Clipboard from 'clipboard'
import './CopyButton.css'

class CopyButton extends Component {
  constructor () {
    super()
    this.state = {
      copied: false
    }
  }

  render () {
    const { text, label, handleClick } = this.props
    const { copied } = this.state
    return (
      <div className='CopyButton'>
        <div className='CopyButton-left'>
          <span className='CopyButton-label'>{label}</span>
          <input className='CopyButton-text' value={text} readOnly />
        </div>
        <div className='CopyButton-right'>
          <button className='CopyButton-button' data-clipboard-text={text} onClick={handleClick} ref={ref => (this.button = ref)}>
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
      </div>
    )
  }

  componentDidMount () {
    const clipboard = new Clipboard(this.button)
    clipboard.on('success', () => {
      this.setState({ copied: true })
      setTimeout(() => { this.setState({ copied: false }) }, this.props.duration)
    })
  }
}

CopyButton.defaultProps = {
  duration: 2000,
  handleClick: () => {}
}

CopyButton.propTypes = {
  duration: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  text: PropTypes.string.isRequired
}

CopyButton.displayName = 'CopyButton'

export default CopyButton



// WEBPACK FOOTER //
// ./ui/CopyButton.js